import { useState } from "react";

export function useGeolocation() {
  const [coords, setCords] = useState(null);
  const [locationError, setLocationError] = useState(null);

  //Get user location
  function getLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        setUserLocation,
        setUserLocationFalse
      );
    } else {
      console.warn("Geolocation is not supported by this browser.");
    }
  }

  function setUserLocation(coordinates) {
    setCords({
      latitude: coordinates.coords.latitude,
      longitude: coordinates.coords.longitude
    });
  }

  function setUserLocationFalse() {
    setLocationError("User restrict access to hes geolocation");
  }

  return {
    coords,
    locationError,
    getLocation
  };
}
